import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  useUserContext,
  IError,
  IApiCallStatus,
  getHeaders,
  ResponseCSOSHeaders,
  getRenewables,
  IPageable,
  IRenewable,
} from '..';
import { fold, map as emap } from 'fp-ts/lib/Either';
import { compose as lcompose } from 'lodash/fp';

export function useRenewables() {
  const { user } = useUserContext();

  const [renewables, setRenewables] = useState<IPageable<IRenewable>>({
    total: 0,
    as: [],
  });
  const [status, setStatus] = useState<IApiCallStatus>(null);

  useEffect(() => {
    lcompose(emap(handleRequest(setStatus)(setRenewables)), getHeaders)(user);
  }, [user]);

  return { renewables, getRenewablesCallStatus: status };
}

//TODO handle error

const handleRequest =
  (setStatus: Dispatch<SetStateAction<IApiCallStatus>>) =>
  (setRenewables: Dispatch<SetStateAction<IPageable<IRenewable>>>) =>
  (hR: ResponseCSOSHeaders) =>
    getRenewables(hR)
      .then(
        fold<IError, IPageable<IRenewable>, void>(
          console.error,
          lcompose(() => setStatus(true), setRenewables)
        )
      )
      .catch(console.log);
